import { lib, i18n as i18nGiscube } from '@giscube/geoportal'
import i18nMapia from 'src/i18n'

function setup (msgs) {
  // support to merge here and on the children's i18n folder
  let messages = i18nGiscube.merge(i18nMapia)
  if (msgs) {
    if (msgs instanceof lib.Options) {
      messages = msgs
    } else {
      messages = messages.merge(msgs)
    }
  }

  return messages
}

const i18nBoot = setup()
i18nBoot.setup = setup

export default i18nBoot
